import React from 'react';
import { HKPlatform } from 'core/constants';
import { RootState } from 'core/store';
import { useSelector } from 'react-redux';
import './LoadingListSkeletalLoader.scss';

interface LoadingListSkeletalLoaderProps {
  className?: string;
}

const LoadingListSkeletalLoader: React.FC<LoadingListSkeletalLoaderProps> = ({
  className = ''
}) => {
  const { platformType, isDesktopWidth } = useSelector(
    (state: RootState) => state.platform
  );

  function DesktopSkeletonItem() {
    return (
      <div className="hk-desktop-document-card-skeleton">
        <div className="hk-desktop-document-card-thumbnail">
          <div className="hk-skeleton-rectangle hk-skeleton-thumbnail"></div>
        </div>
        <div className="hk-desktop-document-card-label">
          <div className="hk-skeleton-oval hk-skeleton-title"></div>
          <div className="hk-skeleton-oval hk-skeleton-description"></div>
        </div>
        <div className="hk-skeleton-oval hk-skeleton-arrow"></div>
      </div>
    );
  }

  function MobileSkeletonItem() {
    return (
      <div className="hk-document-card-skeleton">
        <div className="hk-document-card-thumbnail">
          <div className="hk-skeleton-rectangle hk-skeleton-thumbnail"></div>
        </div>
        <div className="hk-document-card-label">
          <div className="hk-skeleton-oval hk-skeleton-title"></div>
          <div className="hk-skeleton-oval hk-skeleton-description"></div>
        </div>
      </div>
    );
  }

  const SkeletonItem =
    platformType === HKPlatform.DESKTOP && isDesktopWidth
      ? DesktopSkeletonItem
      : MobileSkeletonItem;

  return (
    <div
      className={`hk-list-view-skeletal-loader ${className}`.trim()}
      style={!isDesktopWidth ? { padding: '16px' } : undefined}
    >
      <SkeletonItem />
      <SkeletonItem />
      <SkeletonItem />
    </div>
  );
};

export default LoadingListSkeletalLoader;
